<template>
  <div class="container">
    <div :id="id">
      <img v-if="onlyInitials" ref="avatarImage" alt :style="styles" />
      <img v-else :src="url" alt :style="styles" />
      <h6 v-if="!hideNickName">{{ displayName }}</h6>
    </div>

    <b-popover
      v-if="hideNickName && onlyInitials"
      :target="id"
      triggers="hover focus"
      :content="displayName"
      placement="top"
    ></b-popover>
  </div>
</template>
<script>
import { mapState } from "vuex"
import AvatarInitials from "avatar-initials"
import Utils from "@/utils"

export default {
  layout: "default",
  name: "ProjectAvatar",
  props: {
    onlyInitials: {
      type: Boolean,
      default: false
    },
    imageUrl: {
      type: String,
      default: ""
    },
    user: {
      type: Object,
      required: false,
      default: null
    },
    nickName: {
      type: String,
      default: ""
    },
    hideNickName: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 40
    },
    widthInPercent: {
      type: Boolean,
      default: false
    },
    height: {
      type: Number,
      default: 43
    },
    borderRadius: {
      type: Number,
      default: 50
    },
    fontSize: {
      type: Number,
      default: 10
    }
  },
  data() {
    return {
      id: Utils.generateGuid()
    }
  },
  computed: {
    ...mapState({
      users: state => state.users.all
    }),
    url() {
      // if (this.user.id === "") return this.imageUrl
      //For unassigned user
      if (this.user?.id === "**Unassigned**")
        return require("@/assets/images/unassigned.png")
      return this.user?.avatar ?? require("@/assets/images/unassigned.png")
    },
    displayName() {
      return this.user?.firstName
    },
    styles() {
      return {
        "max-width": "unset",
        width: `${this.width}${this.widthInPercent ? "%" : "px"}`,
        height: this.widthInPercent ? "auto" : `${this.width}px`,
        borderRadius: `${this.borderRadius}%`
      }
    },
    userInitials() {
      return `${this.user?.firstName
        .substr(0, 1)
        .toUpperCase()} ${this.user.lastName.substr(0, 1).toUpperCase()}`
    }
  },
  mounted() {
    if (this.onlyInitials) {
      var avatar = new AvatarInitials(this.$refs.avatarImage, {
        useGravatar: false,
        initials: this.userInitials,
        initial_fg: "black",
        initial_font_family: "Nunito,sans-serif",
        initial_weight: 400,
        initial_size: this.fontSize
      })
      //this needs to be here to fix weird bug on overview page
      avatar.initial_size = 10
    }
  }
}
</script>
<style scoped>
.container {
  width: fit-content;
  display: inline-block;
  text-align: center;
  padding: 0;
}
h6 {
  margin: 0;
}
</style>
